import React, { Component } from 'react'
import PropTypes from 'prop-types'
import exact from 'prop-types-exact'
import '../../styles/modal.pcss'
import { TEMPORARY_PROFILE_SAVE_MODAL } from './Modals'
import GenericModal from './GenericModal'
import { resetTemporaryProfile } from '../../user/userActions'
import { Cookies } from 'react-cookie'
import { loginAlmaTunnus } from '../../user/almalogin/almaUserActions'

export default class ProfileSaveModal extends Component {
  render() {
    const { onClose } = this.props

    return (
      <GenericModal
        modalId={ TEMPORARY_PROFILE_SAVE_MODAL }
        onClose={ onClose }
        onOkClick={ this.handleOk }
        onCancelClick={ this.handleCancel }
        title='Amppareiden väliaikainen profiili poistuu'
        okButtonTxt='Tallenna valinnat luomalla Alma-tunnus'
        cancelButtonTxt='Tyhjennä tekemäsi valinnat'
        requireUserInput={ false }
      >
        <p>Mahdollisuus käyttää väliaikaista profiilia poistuu pian Amppareista. Mikäli haluat käyttää väliaikaisen profiilisi asetuksia jatkossa, voit luoda Alma-tunnuksen.</p>
      </GenericModal>
    )
  }

  handleOk = () => {
    this.props.dispatch(loginAlmaTunnus())
  }

  handleCancel = () => {
    const cookies = new Cookies()
    this.props.dispatch(resetTemporaryProfile(cookies, true))
  }
}

ProfileSaveModal.propTypes = exact({
  onClose: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
})
